import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Card from '../card'
import FontAwesome from '../font-awesome'

import './course.scss'

class Course extends Component {
  render() {
    return (
      <Card className='course'>
        <header className='course__header'>
          <div className='course__header-left'>
            {this.props.salary ? (
              <FontAwesome
                className='course__icon course__icon--salary'
                icon='money-bill-wave'
              />
            ) : (
              <FontAwesome
                className='course__icon course__icon--fire'
                icon='gem'
              />
            )}
            <div className='course__title-container'>
              <p className={`course__description g--margin-none`}>
                <b className='course__title g--margin-none g--font-body-bold'>
                  {this.props.skill}
                  {'. '}
                </b>
                {this.props.desc}
              </p>
            </div>
            {this.props.salary && (
              <p className='course__salary g--margin-none g--font'>
                {Math.round(this.props.salary) < 0
                  ? `${Math.round(this.props.salary)}% salary decline (est)`
                  : `+${Math.round(this.props.salary)}% salary growth (est)`}
              </p>
            )}
          </div>
          <div className='course__icon-container'></div>
        </header>
      </Card>
    )
  }
}

Course.propTypes = {
  skill: PropTypes.string,
  salary: PropTypes.string,
  desc: PropTypes.string,
  href: PropTypes.string
}

export default Course
